import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isFundMaster = location.pathname === '/fundmaster';
  const getFormUrl = () => {
    return isFundMaster ? 'https://forms.gle/5Ka2gvuC9peDhBWv7' : 'https://forms.gle/ZfyxmjxEBEwmtEhs8';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white/95 backdrop-blur-sm border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="relative">
              <div className="w-10 h-10 rounded-lg bg-white border border-slate-200 flex items-center justify-center">
                <img 
                  src="https://customer-assets.emergentagent.com/job_index-wealth-1/artifacts/7uycqeio_designlogo.png" 
                  alt="IndexMaster Logo" 
                  className="w-6 h-6 object-contain"
                  style={{
                    filter: 'brightness(0) saturate(100%) invert(29%) sepia(100%) saturate(1000%) hue-rotate(200deg) brightness(80%) contrast(150%) drop-shadow(0 0 1px rgb(37, 99, 235))'
                  }}
                />
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-800">{isFundMaster ? 'FundMaster' : 'IndexMaster'}</h1>
              <p className="text-xs text-slate-500 hidden sm:block">Investment Approach</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <a href="#approach" className="text-slate-600 hover:text-blue-600 transition-colors font-medium">Approach</a>
            <a href="#manager" className="text-slate-600 hover:text-blue-600 transition-colors font-medium">Fund Manager</a>
            <a href="#benefits" className="text-slate-600 hover:text-blue-600 transition-colors font-medium">Benefits</a>
            <a href="#contact" className="text-slate-600 hover:text-blue-600 transition-colors font-medium">Contact</a>
            <a href="https://forms.gle/G7CPParsvDGe49Ck9" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-green-600 transition-colors font-medium">Partner with Us</a>
            <a href="https://www.orbisonline.in/portal/account/login.aspx" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-purple-600 transition-colors font-medium">Client Login</a>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Button 
              onClick={() => window.open(getFormUrl(), '_blank')}
              className="bg-gradient-to-r from-blue-500 to-green-500 hover:from-blue-600 hover:to-green-600 text-white px-6 py-2 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Open Account
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleMenu}
              className="text-slate-600"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 pt-2">
            <nav className="flex flex-col space-y-3">
              <a href="#approach" className="text-slate-600 hover:text-blue-600 transition-colors py-2 border-b border-slate-100">Approach</a>
              <a href="#manager" className="text-slate-600 hover:text-blue-600 transition-colors py-2 border-b border-slate-100">Fund Manager</a>
              <a href="#benefits" className="text-slate-600 hover:text-blue-600 transition-colors py-2 border-b border-slate-100">Benefits</a>
              <a href="#contact" className="text-slate-600 hover:text-blue-600 transition-colors py-2 border-b border-slate-100">Contact</a>
              <a href="https://forms.gle/G7CPParsvDGe49Ck9" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-green-600 transition-colors py-2 border-b border-slate-100">Partner with Us</a>
              <a href="https://www.orbisonline.in/portal/account/login.aspx" target="_blank" rel="noopener noreferrer" className="text-slate-600 hover:text-purple-600 transition-colors py-2 border-b border-slate-100">Client Login</a>
              <Button 
                onClick={() => window.open(getFormUrl(), '_blank')}
                className="bg-gradient-to-r from-blue-500 to-green-500 text-white mt-4"
              >
                Open Account
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};